<template>
  <el-main>
    <el-form :inline="true" size="small" class="pull-right">
      <el-form-item>
        <el-button type="primary" v-if="admin.actions.indexOf('isadd') != -1" @click="addAdmin">添加人员</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="lists" border header-cell-class-name="table-header">
      <el-table-column label="序号" align="center" prop="aid" width="80">
      </el-table-column>
      <el-table-column label="角色名称" prop="gid">
        <template slot-scope="scope">{{groups[scope.row.gid] ? groups[scope.row.gid].title : ""}}</template>
      </el-table-column>
      <el-table-column label="姓名" prop="realname"></el-table-column>
      <el-table-column label="登录账号" prop="username"></el-table-column>
      <el-table-column label="最后登录" prop="lasttime" align="center">
        <template slot-scope="scope">{{scope.row.lasttime | timeTodate("Y-m-d H:i:s")}}</template>
      </el-table-column>
      <el-table-column label="创建时间" prop="dateline" align="center">
        <template slot-scope="scope">{{scope.row.dateline | timeTodate("Y-m-d H:i:s")}}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" circle size="small" v-if="admin.actions.indexOf('isedit') != -1"
            @click="editAdmin(scope.$index, scope.row)"></el-button>
          <el-button type="danger" icon="el-icon-delete" circle size="small" v-if="admin.actions.indexOf('isdel') != -1"
            @click="delAdmin(scope.$index, scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination background layout="sizes, prev, pager, next, total" :page-sizes="[10, 15, 20, 50, 100]"
      @size-change="handleSizeChange" @current-change="getLists" :current-page="page" :page-size="$store.state.offset" :total="totals">
    </el-pagination>

    <!-- 添加信息 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <el-form v-model="adminForm" label-position="right" label-width="120px" label-suffix="：">
        <el-form-item label="人员角色">
          <el-select v-model="adminForm.gid" placeholder="选择角色">
            <el-option v-for="group in groups" :key="group.gid" :label="group.title" :value="group.gid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员姓名">
          <el-input v-model="adminForm.realname" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="登录帐号">
          <el-input v-model="adminForm.username" placeholder="请输入登录账号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="adminForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="密码确认">
          <el-input v-model="adminForm.checkpassword" type="password"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="dialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="saveAdmin">确 定</el-button>
      </template>
    </el-dialog>
  </el-main>
</template>
<script>
  import {
    httpRequest,
    passwordCheck,
    getCookie
  } from '@/utils/app'
  export default {
    data() {
      return {
        admin: {},
        groups: [],
        totals: 0,
        page: 1,
        lists: [],
        adminForm: {
          uid: 0,
          pid: 0,
          gid: '',
          aid: 0,
          username: '',
          password: '',
          checkpassword: '',
          realname: ''
        },
        dialogTitle: '添加人员',
        dialogVisible: false
      }
    },

    created() {
      // 登录用户
      this.admin = getCookie('admin')

      // 获取用户分组键值对
      httpRequest({
        action: 'adminGroup_cates'
      }).then(response => {
        if (response.error === false) {
          this.groups = response.data
        }
      })

      this.getLists(1)
    },
    methods: {
      // 每页条数变更：写入 Vuex + localStorage（全局共享）后重新加载
      handleSizeChange(e) {
        this.$store.commit('setOffset', e)
        this.getLists(1)
      },
      // 添加信息
      addAdmin() {
        this.adminForm = {
          uid: 0,
          gid: '',
          pid: this.admin.pid,
          aid: 0,
          realname: '',
          username: '',
          password: '',
          checkpassword: ''
        }
        this.dialogTitle = '添加人员'
        this.dialogVisible = true
      },
      editAdmin(index, row) {
        row.password = ''
        this.adminForm = row
        this.adminForm.gid = parseInt(row.gid)
        this.dialogTitle = '编辑人员'
        this.dialogVisible = true
      },
      delAdmin(index, row) {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          httpRequest({
              action: 'admin_delete',
              aid: row.aid
            })
            .then(response => {
              if (response.error === false) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.lists.splice(index, 1)
              }
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      saveAdmin() {
        var params = {}
        params.action = 'admin_add'
        params.aid = this.adminForm.aid
        params.gid = this.adminForm.gid
        params.username = this.adminForm.username + ''
        params.password = this.adminForm.password + ''
        params.realname = this.adminForm.realname + ''

        if (params.realname.trim() === '') {
          this.$message({
            type: 'error',
            message: '人员姓名不得为空'
          })
          return
        }

        if (params.username.trim() === '') {
          this.$message({
            type: 'error',
            message: '登录帐号不得为空'
          })
          return
        }

        if (params.aid === 0 && params.password.trim() === '') {
          this.$message({
            type: 'error',
            message: '创建新用户必须输入登录密码'
          })
          return
        }

        if (params.password.trim() && params.password !== this.adminForm.checkpassword) {
          this.$message({
            type: 'error',
            message: '登录密码不一致'
          })
          return
        }

        if (params.password.trim() && !passwordCheck(params.password)) {
          this.$message({
            type: 'error',
            message: '请输入8-30位含2种组合的密码（数字、字母)'
          })
          return
        }

        let that = this
        httpRequest(params)
          .then(response => {
            if (response.error) {
              this.$message({
                type: 'error',
                message: response.msg
              })
            } else {
              this.dialogVisible = false
              this.$message({
                type: 'success',
                message: response.msg,
                onClose: function() {
                  that.getLists(that.page)
                }
              })
            }
          })
      },
      getLists(page) {
        httpRequest({
            action: 'admin_lists',
            page: page,
            offset: this.$store.state.offset,
            isdel: '0'
          })
          .then(response => {
            if (response.error) {

            } else {
              this.page = page
              this.lists = response.data
              this.totals = parseInt(response.totals)
            }
          })
      }

    }
  }
</script>